import { getPosition } from "./playbackPosition.js";

export function addAttributes(htmlString) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  const elements = doc.querySelectorAll("video, audio");
  let id = 0;
  for (let element of elements) {
    if (element.tagName === "VIDEO") {
      element.setAttribute("playsinline", "true");
      element.setAttribute("style", "aspect-ratio: 16 / 9; width: 100%;");
    }
    id += 1;
    element.setAttribute("id", `${id}-load`);
    element.setAttribute("preload", "auto");
    const src = element.src.replace(/'/g, "");
    // When there are hebrew letters in the src value they are encoded when passed as an argument
    const decodedSrc = decodeURIComponent(src);
    // Updating the element's id is necessary to avoid conflicts between the getting and setting cookies functions. For example when there is a cookie setting the media current time which would also trigger the timeupdate event to set the cookie again.
    element.setAttribute(
      "ontimeupdate",
      `
        if (document.getElementById('${id}')) {
          setCookie('${decodedSrc}', '${id}');
        } else if (document.getElementById('${id}-load')) {
          document.getElementById('${id}-load').setAttribute("id", '${id}')
        }
      `
    );
    const cookie = getPosition(decodedSrc);
    if (cookie) {
      element.setAttribute("src", `${element.src}#t=${cookie}`);
    } else {
      element.setAttribute("id", `${id}`);
    }
  }
  return doc.body.innerHTML;
}
